var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStackedCol(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 104,
    height: 53,
    viewBox: "0 0 104 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_224_2817)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.157959,
    width: 103.579,
    height: 52.3759,
    rx: 2.90977,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.157867,
    y: 43.1579,
    width: 6.47368,
    height: 9.5,
    fill: "#A2ABCC"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.71051,
    y: 44.2368,
    width: 7.55263,
    height: 8.3,
    fill: "#A2ABCC"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16.3421,
    y: 45.3158,
    width: 7.55263,
    height: 7.3,
    fill: "#A2ABCC"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24.9737,
    y: 46.3947,
    width: 7.55263,
    height: 6,
    fill: "#A2ABCC"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 33.6052,
    y: 45.3158,
    width: 7.55263,
    height: 7.1,
    fill: "#A2ABCC"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 42.2368,
    y: 47.4737,
    width: 7.55263,
    height: 5,
    fill: "#A2ABCC"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 50.8684,
    y: 46.3947,
    width: 7.55263,
    height: 6,
    fill: "#A2ABCC"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 59.5,
    y: 47.4737,
    width: 7.55263,
    height: 5,
    fill: "#A2ABCC"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 68.1316,
    y: 48.5526,
    width: 7.55263,
    height: 4,
    fill: "#A2ABCC"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7.55263,
    height: 2.5,
    transform: "matrix(1 0 0 -1 76.7631 52.5)",
    fill: "#A2ABCC"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 85.3947,
    y: 49.6316,
    width: 7.55263,
    height: 3,
    fill: "#A2ABCC"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 94.0263,
    y: 49.6316,
    width: 7.55263,
    height: 3,
    fill: "#A2ABCC"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.157867,
    y: 33.4474,
    width: 6.47368,
    height: 9.71053,
    fill: "#6371A8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.71051,
    y: 34.5263,
    width: 7.55263,
    height: 9.71053,
    fill: "#6371A8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16.3421,
    y: 39.921,
    width: 7.55263,
    height: 5.39474,
    fill: "#6371A8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24.9737,
    y: 38.8421,
    width: 7.55263,
    height: 7.55263,
    fill: "#6371A8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 33.6052,
    y: 41,
    width: 7.55263,
    height: 4.31579,
    fill: "#6371A8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 42.2368,
    y: 37.7631,
    width: 7.55263,
    height: 9.71053,
    fill: "#6371A8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 50.8684,
    y: 38.8421,
    width: 7.55263,
    height: 7.55263,
    fill: "#6371A8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 59.5,
    y: 37.7631,
    width: 7.55263,
    height: 9.71053,
    fill: "#6371A8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 68.1316,
    y: 42.0789,
    width: 7.55263,
    height: 6.47368,
    fill: "#6371A8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 76.7631,
    y: 46.3947,
    width: 7.55263,
    height: 4.31579,
    fill: "#6371A8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 85.3947,
    y: 44.2368,
    width: 7.55263,
    height: 5.39474,
    fill: "#6371A8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 94.0263,
    y: 46.3947,
    width: 7.55263,
    height: 3.23684,
    fill: "#6371A8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.157867,
    y: 17.2631,
    width: 6.47368,
    height: 16.1842,
    fill: "#DADFF2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.71051,
    y: 17.2631,
    width: 7.55263,
    height: 17.2632,
    fill: "#DADFF2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16.3421,
    y: 19.421,
    width: 7.55263,
    height: 20.5,
    fill: "#DADFF2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24.9737,
    y: 20.5,
    width: 7.55263,
    height: 18.3421,
    fill: "#DADFF2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 33.6052,
    y: 31.2895,
    width: 7.55263,
    height: 9.71053,
    fill: "#DADFF2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 42.2368,
    y: 25.8947,
    width: 7.55263,
    height: 11.8684,
    fill: "#DADFF2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 50.8684,
    y: 20.5,
    width: 7.55263,
    height: 18.3421,
    fill: "#DADFF2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 59.5,
    y: 26.9737,
    width: 7.55263,
    height: 10.7895,
    fill: "#DADFF2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 68.1316,
    y: 31.2895,
    width: 7.55263,
    height: 10.7895,
    fill: "#DADFF2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 76.7631,
    y: 38.8421,
    width: 7.55263,
    height: 7.55263,
    fill: "#DADFF2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 85.3947,
    y: 37.7631,
    width: 7.55263,
    height: 6.47368,
    fill: "#DADFF2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 94.0263,
    y: 39.921,
    width: 7.55263,
    height: 6.47368,
    fill: "#DADFF2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_224_2817"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.157959,
    width: 103.579,
    height: 52.3759,
    rx: 2.90977,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStackedCol);
export default __webpack_public_path__ + "static/media/stacked-col.44f962666eeac759fddf5046edf7f3ca.svg";
export { ForwardRef as ReactComponent };